export const messagesLoginPersonalize = {
    pt: {
        message:{
            acceptAll: "Aceitar todos",
            acceptTermsOfUse: "Aceito os Termos de Uso",
            acceptanceText: "Aceito receber todo o conteúdo sobre Marcas, Produtos, Programas de Fidelidade, Ofertas, Promoções e Eventos dos anunciantes parceiros ao WiFeed, via meios de contato por mim inseridos ativamente, tais como e-mail e celular.",
            activatePhoneValidation: "Ativar validação de telefone",
            activateEmailValidation: "Ativar validação de e-mail",
            addForm: 'Adicionar formulário',
            alreadyRegistered: "Já é cadastrado?",
            apply: "Aplicar",
            background: "Fundo",
            boolean: "Booleano",
            buttonBackground: "Fundo Botão",
            buttonFont: "Texto Botão",
            byRegistering: "Ao se cadastrar você concoda com os",
            changeLogo: "Alterar logotipo",
            setBackground: "Inserir imagem de fundo",
            changeRegistration: "ALTERAR CADASTRO",
            create: "Criar",
            createCustomization: "Criar customização",
            createRegistrationFormField: "Criar campo do formulário",
            custom: "Personalizado",
            dateOfBirth: "Data de Nascimento",
            deleteStyle: 'Deletar Customização?',
            deleteStyleConfirm: 'Quer mesmo deletar esta customização? Esta ação é irreversível',
            deleteField: "Deletar Campo",
            deleteFieldConfirmation: "Quer mesmo deletar este campo?",
            deletingFieldWarning: "Caso este campo estiver sendo utilizado como um filtro nos fluxos de automação de marketing, o fluxo ficará inativo. Por favor, verifique seus fluxos.",
            warning: "Atenção: ",
            deleteForm: "Deletar formulário?",
            deleteFormConfirmation: "Quer mesmo deletar este formulário? Esta ação é irreversível",
            doNotInform: "Não informar",
            editFields: "Editar campos",
            editForm: "Editar formulário",
            editLoginTypes: "Editar tipos de login",
            editRegistrationFields: "Editar campos do cadastro",
            enabledFields: "Campos Habilitados",
            externalService: "Serviço externo",
            fieldLabel: "Legenda do campo",
            fieldLabelHelp: "A legenda do campo será vista pelos usuários ao preencher o cadastro",
            fieldName: "Nome do campo",
            fieldNameHelp: "O nome do campo só será visualizado dentro do WiFeed",
            fields: "Campos",
            fieldType: "Tipo de campo",
            form: "Formulário",
            fullName: "Nome Completo",
            integration: "Integração",
            justThisOnce: "apenas desta vez!",
            key: "Chave",            
            letter: "Uma letra",
            login: "Entrar",
            loginButtonLabel: "Título do botão",
            loginTypes: "Tipos de login",
            loginWithEmail: "Entrar com o e-mail",
            loginWithFacebook: "Entrar com o Facebook",
            loginWithLinkedin: "Entrar com o Linkedin",
            maskType: "Tipo de máscara",
            noForm: "Sem formulário",
            noLoginTypeFound: 'Nenhum tipo de login encontrado',
            number0to9: "Um número de 0-9",
            numbers0to9: "Números de 0-9",
            addOptionAndPressEnter: "Adicione uma opção e tecle enter",
            options: "Opções",
            phoneValidationWarning: "A validação de telefone depende de créditos de SMS na conta, caso ainda não tenha créditos adicionados entre em contato com nosso suporte.",
            placeholder: "Placeholder",
            predefined: "Pré-definidas",
            registrationField: "Campo do cadastro",
            registrationFields: "Campos do cadastro",
            registrationForm: "Formulário de cadastro",
            registrationType: "Tipo de cadastro",
            removeLogo: "Remover logotipo",
            required: "Obrigatório",
            selectFile: "Selecionar arquivo",
            selectRequiredField: "Selecione o campo obrigatório",
            selectType: "Selecione o tipo",
            telephone: "Telefone",
            termsOfUse: "Termos de uso",
            text: "Texto",
            type: 'Tipo',
            typeDisabled: "Este tipo de cadastro está desabilitado momentâneamente na plataforma",
            vlanTooltip: "CUIDADO! A VLAN inserida será utilizada para a mudança de rede pós-liberação, essa funcionalidade está limitada a alguns equipamentos, e a inserção da VLAN pode causar falha na conexão dos clientes. Entre em contato com o nosso suporte para mais informações.",
            font: "Texto",
            weAlsoDontLike: "Também não gostamos de cadastros, por isso você o fará",
            initialPhrase: "Frase inicial",
            deleteLoginType: 'Deletar envio?',
            deleteLoginTypeConfirmation: 'Quer mesmo deletar este envio? Esta ação é irreversível.'
        }
    },
    es: {
        message:{
            setBackground: "Insertar imagen de fondo",
            acceptAll: "Aceptar todo",
            acceptTermsOfUse:"Acepto los términos de uso",
            acceptanceText:"Acepto recibir todo el contenido sobre marcas, productos, programas de fidelización, ofertas, promociones y eventos de los anunciantes asociados para esposa, a través de Active Contact By ME activamente, como el correo electrónico y el móvil",
            activatePhoneValidation: "Habilitar la validación del teléfono",
            activateEmailValidation: "Habilitar la validación de correo electrónico",
            addForm: 'Agregar formulario',
            alreadyRegistered:"¿Ya está registrado?",
            apply: "Aplicar",
            background:"Fondo",
            boolean: "Booleano",
            buttonBackground:"Botón de retroceso",
            buttonFont:"Botón de texto",
            byRegistering:"Al registrarse usted está de acuerdo con el",
            changeLogo:"Cambiar logotipo",
            changeRegistration:"Cambiar registro",
            create: "Crear",
            createCustomization: "Crear personalización",
            createRegistrationFormField: "Criar campo do formulario",
            custom:"Personalizado",
            dateOfBirth:"Fecha de nacimiento",
            deleteStyle: '¿Eliminar personalización?',
            deleteStyleConfirm: '¿Realmente deseas eliminar esta personalización? Esta acción es irreversible',
            deleteField: "Eliminar Campo",
            deleteFieldConfirmation: "¿Realmente desea eliminar este campo?",
            deletingFieldWarning: "Si este campo se utiliza como filtro en los flujos de automatización de marketing, el flujo estará inactivo. Por favor revise sus flujos.",
            warning: "Atención: ",
            deleteForm: "¿Eliminar formulario?",
            deleteFormConfirmation: "¿Realmente desea eliminar este formulario? Esta acción es irreversible.",
            doNotInform:"No Informar",
            editFields: "Editar campos",
            editForm: "Editar formulario",
            editLoginTypes: "Editar tipos de inicio de sesión",
            editRegistrationFields: "Editar campos de registro",
            enabledFields: "Campos Habilitados",
            externalService: "Servicio externo",
            fieldLabel: "Título de campo",
            fieldLabelHelp: "El título del campo será visto por los usuarios al completar el registro",
            fieldName: "Nombre del campo",
            fieldNameHelp: "El nombre del campo solo se mostrará dentro del WiFeed",
            fields: "Campos",
            fieldType: "Tipo de campo",
            form:"Formulario",
            fullName:"Nombre completo",
            integration: "Integración",
            justThisOnce:"¡Solo esta vez!",
            key: "Clave",
            label: "Label",
            letter: "Una letra",
            login:"Entrar",
            loginButtonLabel: "Título del botón",
            loginTypes: "Tipos de inicio de sesión",
            loginWithEmail:"Ingrese con el correo electrónico",
            loginWithFacebook:"Ingresar con Facebook",
            loginWithLinkedin:"Ingresar con LinkedIn",
            maskType: "Tipo de máscara",
            noForm: "Sin formulario",
            noLoginTypeFound: 'No se encontró ningún tipo de inicio de sesión',
            number0to9: "Un número del 0 al 9",
            numbers0to9: "Números del 0 al 9",
            addOptionAndPressEnter: "Agrega una opción y presiona enter",
            options: "Opciones",
            phoneValidationWarning: "La validación del teléfono depende de los créditos de SMS en la cuenta; si aún no tiene créditos agregados, comuníquese con nuestro soporte.",
            placeholder: "Placeholder",
            predefined:"Predefinido",
            registrationField: "Campo de registro",
            registrationFields: "Campos de registro",
            registrationForm: "Formulario de inscripción",
            registrationType:"Tipo de registro",
            removeLogo: "Eliminar logotipo",
            required: "Obligatorio",
            selectFile:"Seleccione Archivo",
            selectRequiredField: "Seleccionar campo requerido",
            selectType: "Seleccione el tipo",
            telephone: "Teléfono",
            termsOfUse:"Terminos de uso",
            text: "Texto",
            type: 'Tipo',
            typeDisabled: "Este tipo de registro se encuentra actualmente deshabilitado en la plataforma",
            vlanTooltip: "¡CUIDADOSO! La VLAN insertada se utilizará para el cambio de red posterior al lanzamiento; esta funcionalidad está limitada a algunos equipos y la inserción de la VLAN puede provocar una falla en la conexión del cliente. Póngase en contacto con nuestro soporte para más información.",
            font:"Texto",
            weAlsoDontLike: "A nosotros tampoco nos gustan los registros, así que solo lo harás",
            initialPhrase: "Frase de apertura",
            deleteLoginType: '¿Borrar envío?',
            deleteLoginTypeConfirmation: '¿Está seguro que desea eliminar este envío? Esta acción es irreversible.'

        }
    },
    en: {
        message:{
            setBackground: "Insert background",
            acceptAll: "Accept all",
            acceptTermsOfUse: "I accept the terms of use",
            acceptanceText: "I agree to receive all content about Brands, Products, Loyalty Programs, Offers, Promotions and Events from WiFeed partner advertisers, via means of contact that I have actively inserted, such as email and cell phone.",
            activatePhoneValidation: "Enable phone validation",
            activateEmailValidation: "Enable e-mail validation",
            addForm: 'Add form',
            alreadyRegistered: "Already registered?",
            apply: "Apply",
            background: "Background",
            boolean: "Boolean",
            buttonBackground: "Button Background",
            buttonFont: "Button Font",
            byRegistering: "By registering you agree to the",
            changeLogo: "Change logo",
            changeRegistration: "CHANGE REGISTRATION",
            create: "Create",
            createRegistrationFormField: "Create registration form field",
            createCustomization: "Create customization",
            custom: "Custom",
            dateOfBirth: "Date of Birth",
            deleteField: "Delete Field",
            deleteStyle: 'Delete Style?',
            deleteStyleConfirm: 'Do you really want to delete this customization? This action is irreversible',
            deleteFieldConfirmation: "Do you really want to delete this field?",
            deletingFieldWarning: "If this field is being used as a filter in marketing automation flows, the flow will be inactive. Please check your streams.",
            warning: "Attention: ",
            deleteForm: "Delete form?",
            deleteFormConfirmation: "Do you really want to delete this form? This action is irreversible",
            doNotInform: "Do not inform",
            editFields: "Edit fields",
            editForm: "Edit form",
            editLoginTypes: "Edit login types",
            editRegistrationFields: "Edit registration fields",
            enabledFields: "Enabled Fields",
            externalService: "External service",
            fieldLabel: "Label",
            fieldLabelHelp: "The caption of the field will be seen by users when completing the registration",
            fieldName: "Name",
            fieldNameHelp: "The field name will only be displayed within WiFeed",
            fields: "Fields",
            fieldType: "Field type",
            form: "Form",
            fullName: "Full Name",
            integration: "Integration",
            justThisOnce: "just this once!",
            key: "Key",
            label: "Label",
            letter: "One letter",
            login: "Login",
            loginButtonLabel: "Button label",
            loginTypes: "Login types",
            loginWithEmail: "Login with e-mail",
            loginWithFacebook: "Login with Facebook",
            loginWithLinkedin: "Login with Linkedin",
            maskType: "Mask type",
            noForm: "No form",
            noLoginTypeFound: 'No login type found',
            number0to9: "A number from 0-9",
            numbers0to9: "Numbers from 0-9",
            addOptionAndPressEnter: "Add an option and press enter",
            options: "Options",
            phoneValidationWarning: "Phone validation depends on SMS credits in the account, if you don't have credits added yet, contact our support.",
            placeholder: "Placeholder",
            predefined: "Predefined",
            registrationField: "Registration field",
            registrationFields: "Registration fields",
            registrationForm: "Registration form",
            registrationType: "Registration type",
            removeLogo: "Remove logo",
            required: "Required",
            selectFile: "Select file",
            selectRequiredField: "Select required field",
            selectType: "Select the type",
            telephone: "Telephone",
            termsOfUse: "Terms of use",
            text: "Text",
            type: 'Type',
            typeDisabled: "This type of registration is currently disabled on the platform",
            vlanTooltip: "CAREFUL! The inserted VLAN will be used for post-release network change, this functionality is limited to some equipment, and inserting the VLAN may cause client connection failure. Contact our support for more information.",
            font: "Font",
            weAlsoDontLike: "We don't like registrations either, so you'll just do it",
            initialPhrase: "Opening phrase",
            deleteLoginType: 'Delete send?',
            deleteLoginTypeConfirmation: 'Are you sure you want to delete this send? This action is irreversible'
        }
    }
}
